module.exports = __webpack_public_path__ + "static/media/hold-phone-down.de66fb57.png";